import { Component, OnInit, EventEmitter } from '@angular/core';
import { BaseComponentService } from '../../../services/base-component.service';
import { IAslibModalOptions } from '@aslib/modal';

@Component({
  selector: 'gpa-liq',
  templateUrl: './liq.component.html',
  providers: [BaseComponentService],
  styles: [
    `
      .fieldRow {
      height:1px; border:none; color:#000; background-color:#000; margin-top: 0px; margin-bottom: 0px;'
      }
  `
  ]
})

export class LiqComponent extends BaseComponentService implements OnInit {

  static idFileLiqCaptured = new EventEmitter<number>();

  dataEnvioLiq: string;
  arquivosLiq: any[];
  arquivoLiq: any;
  habilitarCarregar: boolean;
  projetoIntegrado: string = sessionStorage.getItem('ProjetoIntegrado');
  showTabsNavigation = false;

  ngOnInit() {
    this.dataEnvioLiq = '';
    this.arquivosLiq = [];
    this.arquivoLiq = '';
    this.habilitarCarregar = true;

    sessionStorage.removeItem('IdLiq');

    this.projetoIntegrado = sessionStorage.getItem('ProjetoIntegrado');
  }

  async getArquivoLiq() {
    this.showTabsNavigation = false;
    sessionStorage.removeItem('IdLiq');

    if (this.isNullOrUndefinedOrEmpty(this.dataEnvioLiq)) {
      this.exibirAviso('Favor informar uma data para consulta das LIQs.');
      return;
    }

    this.aslibLoadingService.start();

    try {
      await this.preencheComboDoisParametros('/api/LiqEnvio/ObterInfoLiqsEnviados/', 'arquivosLiq',
        this.projetoIntegrado, this.dataEnvioLiq, 'gpa');

      this.aslibLoadingService.complete();

      if (!this.arquivosLiq || this.arquivosLiq.length === 0) {
        this.exibirAviso('Não foram encontradas LIQs enviadas para a data informada.');
        this.habilitarCarregar = true;
      }
      else {
        this.habilitarCarregar = false;
      }

    } catch (error) {
      this.aslibLoadingService.complete();
      this.exibirErro(error);
    }
  }

  emitterArquivoLiq(fileId: number): void {

    if (this.arquivoLiq === '') {
      this.exibirAviso('Selecione um arquivo para ser enviado.');
    } else {
      this.showTabsNavigation = false;
      setTimeout(() => {
        this.showTabsNavigation = true;
      }, 1000);
      sessionStorage.setItem("IdLiq", fileId.toString());
    }
  }

  openModalParametros(conteudo: any) {
    const options: IAslibModalOptions = {
      title: 'Parâmetros de Pagamento',
      backdrop: 'static',
      cancelarVisible: false,
      size: 'lg',
      content: conteudo
    };

    // Carrega um modal para exibição de mansagem
    this.aslibModal.open(options).result.then(
      () => { },
      () => { }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/pagamento/liq-pagamento/liq/liq.component.ts